import classNames from 'classnames';
import { FlexContainer } from 'components';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { profileTypes } from 'config/types';
import { useProfile } from 'state';
import { Footer, Header, Nav, SideBar } from './components';
import styles from './Layout.module.scss';

const routes = [
  {
    path: 'properties',
    title: 'Properties',
    onlyLandlord: true,
  },
  {
    path: 'tenancies',
    title: 'Tenancies',
    onlyTenant: true,
  },
  {
    path: 'payments',
    title: 'Payments',
    onlyTenant: true,
  },
  {
    path: 'search',
    title: 'Search',
  },
  {
    path: 'banking',
    title: 'Banking',
    onlyLandlord: true,
  },
  {
    path: 'subscription',
    title: 'Subscription',
    onlyLandlord: true,
  },
  {
    path: 'notices',
    title: 'Notices',
  },
];

/**
 * Layout
 *
 * @return {JSX.Element}
 */
const Layout = () => {
  const profile = useProfile();

  const routesFiltered = useMemo(() => {
    const { profileType } = profile.data;
    const isLandlord =
      profileType === profileTypes.LANDLORD ||
      profileType === profileTypes.MANAGER;

    return routes.filter(({ onlyTenant, onlyLandlord }) =>
      isLandlord ? !onlyTenant : !onlyLandlord
    );
  }, [profile.data]);
  return (
    <FlexContainer
      className={classNames(styles.Layout, `${Layout.displayName}`)}
    >
      <SideBar className={styles.SideBar}>
        <FlexContainer spaceBetween flex column gap>
          <Nav routes={routesFiltered} />
          <Footer />
        </FlexContainer>
      </SideBar>
      <FlexContainer flex column maxWidth100>
        <Header className={styles.Header} />
        <FlexContainer className={styles.Body} column flex>
          <Outlet />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

Layout.displayName = 'Layout';

export default observer(Layout);
